import { Injectable } from '@angular/core';
import { OneQmsFileUploaderComponent } from './one-qms-file-uploader/one-qms-file-uploader.component';
import { UploadResult } from '../models/upload-result.model';

@Injectable({
  providedIn: 'root'
})
export class OneQmsFileUploadService {

  private uploaderComponent!: OneQmsFileUploaderComponent;

  register(component: OneQmsFileUploaderComponent) {
    this.uploaderComponent = component;
  }

  uploadSingleFile(formData: FormData): Promise<UploadResult> {

    if (!this.uploaderComponent) {
      throw new Error("Uploader component not registered");
    }

    return this.uploaderComponent.uploadSingleFile(formData);
  }

  uploadMultipleFiles(files: File[], callback?: (res: any) => void) {

    if (!this.uploaderComponent) {
      throw new Error("Uploader component not registered");
    }

    this.uploaderComponent.uploadMultipleFile(files, callback);
  }

}
